import { createContext } from 'react';

type BetaLabelContext = {
  showLabels: boolean;
};

export const BetaLabelsContext = createContext({} as BetaLabelContext);

export const BetaLabelsProvider = BetaLabelsContext.Provider;
